import { Grid, Paper, Typography } from '@material-ui/core';
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web';
import laqusImf from 'assets/laqus-imf-digital-1x.png';
import { ComponentLoader } from 'components/loader';
import Keycloak, { KeycloakConfig } from 'keycloak-js';
import { MdSpace } from 'm2m.components';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useBaseStyles } from './baseStyle';

const Sso: React.FC = () => {
  const { keycloak, initialized } = useKeycloak();
  const history = useHistory();
  const classes = useBaseStyles();

  useEffect(() => {
    if (initialized && keycloak) {
      if (!keycloak.authenticated) {
        keycloak.login();
      } else {
        if (keycloak.token) sessionStorage.setItem('idpToken', keycloak.token);
        history.push('/');
      }
    }
  }, [initialized, keycloak, history]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ margin: '40px 0' }}>
        <Paper className={classes.paper}>
          <Grid container justify="center">
            <Grid item>
              <img src={laqusImf} alt="Logo Laqus IMF digital" />
            </Grid>
            <Grid item sm={12}>
              <MdSpace />
              <Typography align="center" variant="h2">
                {`Acesso corporativo`}
              </Typography>
              <MdSpace />
              <Typography align="center" variant="body2">
                {`Estamos te redirecionando para a autenticação única da Laqus. Aguarde um instante.`}
              </Typography>
              <MdSpace />
            </Grid>
            <Grid item sm={12}>
              <ComponentLoader loaderRelativePosition />
            </Grid>
          </Grid>
        </Paper>
      </div>
    </div>
  );
};

const KeycloakWrap: React.FC = () => {
  const url = process.env['REACT_APP_KEYCLOAK_AUTH_SERVER_URL'];
  const realm = process.env['REACT_APP_KEYCLOAK_REALM'];
  const clientId = process.env['REACT_APP_KEYCLOAK_CLIENT_ID'];

  if (!url || !realm || !clientId) {
    throw new Error('Keycloak config error: missing env vars');
  }

  const keycloakConfig: KeycloakConfig = {
    url,
    realm,
    clientId,
  };

  const keycloak: Keycloak = new Keycloak(keycloakConfig);

  return (
    <ReactKeycloakProvider authClient={keycloak}>
      <Sso />
    </ReactKeycloakProvider>
  );
};

export default KeycloakWrap;
